<template>

  <div class="app-container">

    <el-row :gutter="6" align='middle'>
      <el-col :span="columns.col1">
        <!-- 筛选栏 -->
        <div>
          <!-- 查找参数区 -->

          <div :class="selfAdaption == false ? 'filter-container' : 'filter-container-max'">
            <div>
              <el-input v-model="listQuery" clearable placeholder="请输入车辆ID" prefix-icon="el-icon-search" maxlength="20"
                @keyup.enter.native="handleFilterCar" style="width: 280px;"
                :onkeyup="listQuery = listQuery.replace(/\s+/g,'')">
              </el-input>
            </div>
            <!-- <div class="radio-box" v-for="(item,index) in radios" :key="item.id">
              <span class="radio" :class="{'on':item.isChecked}"></span>
              <input v-model="payType" :value="item.value" class="input-radio" :checked='item.isChecked'
                @click="checkRadio(index)" type="radio">{{item.label}}
            </div> -->

          </div>


          <!-- 列表 -->
          <div>
            <div :class="selfAdaption === false ? 'start-end' : 'start-end-max'">
              <span class="span-start">在线---------------</span>
              <ul id="v-for-object">
                <li v-for="(item,index) in startObject" :class="selfAdaption === false ? 'active' : 'active-max'"
                  @click="showCar(item)" :style="{color:(item == currentIndex ? '#bdbdbd' : '#000')}">
                  <img style="height:30px; width: 30px;" src="../../assets/img/car_free.9.png" alt="向下" />
                  {{ item }}
                </li>
              </ul>
            </div>

            <div :class="selfAdaption === false ? 'start-end' : 'start-end-max'">
              <span class="span-start">离线---------------</span>
              <ul id="v-for-object">
                <li v-for="(item,index) in stopObject" :class="selfAdaption === false ? 'active' : 'active-max'"
                  @click="showCar(item)" :style="{color:(item == currentIndex ? '#bdbdbd' : '#000')}">
                  <img style="height:30px; width: 30px;" src="../../assets/img/car_exception.9.png" alt="向下" />
                  {{ item }}
                </li>
              </ul>
            </div>

            <div :class="selfAdaption === false ? 'start-end' : 'start-end-max'">
              <span class="span-start">接管---------------</span>
              <ul id="v-for-object">
                <li v-for="(item,index) in minaObject" :class="selfAdaption === false ? 'active' : 'active-max'"
                  @click="showCar(item)" :style="{color:(item == currentIndex ? '#bdbdbd' : '#000')}">
                  <img style="height:30px; width: 30px;" src="../../assets/img/car_mobile_renting.9.png" alt="向下" />
                  {{ item }}
                </li>
              </ul>
            </div>

            <div :class="selfAdaption === false ? 'start-end' : 'start-end-max'">
              <span class="span-start">移动---------------</span>
              <ul id="v-for-object">
                <li v-for="(item,index) in moveObject" :class="selfAdaption === false ? 'active' : 'active-max'"
                  @click="showCar(item)" :style="{color:(item == currentIndex ? '#bdbdbd' : '#000')}">
                  <img style="height:30px; width: 30px;" src="../../assets/img/car_coin_renting.9.png" alt="向下" />
                  {{ item }}
                </li>
              </ul>
            </div>

          </div>

          <!-- 数据列表区 -->
          <!-- <el-table :data="carDataList" style="width: 100%; margin:0 auto;align: center; margin-top:30px;" border
            highlight-current-row>
            <el-table-column prop="idStr" label="车辆ID"  align="center" header-align="center">
            </el-table-column>
          </el-table> -->

          <!-- 分页栏 -->
          <pagination-easy :class="selfAdaption === false ? 'pagination-easy-style' : 'pagination-easy-style-max'"
            :total="totalCountsCar" @pagination="handlePageChangeCar" layout='prev, pager, next, jumper'
            :page="listQueryCar.pageIndex" small :pager-count="5">
          </pagination-easy>

          <button class="btn-el" @click="startAllCar">
            一键开启
          </button>
          <button class="btn-el" @click="moveAllCar">
            一键移动
          </button>
          <button class="btn-el" @click="stopAllCar">
            一键停止
          </button>
        </div>

      </el-col>


      <el-col :span="columns.col2">
        <!-- 点云地图 -->
        <div class="point-cloud-map">
          <!-- 点云地图 -->
          <table id="roomMapTable"></table>
        </div>
      </el-col>
      <el-col :span="columns.col3">

        <!-- 地图栏 -->
        <baidu-map class="bm-view" :center="bdmap.center" scroll-wheel-zoom @ready="bm_ready" :zoom="15">

          <!-- 自定义图标 -->
          <bm-control class="rockerCon">

            <div v-show="isImgShow" style="margin-left: -200px; margin-top: 100px;">
              <div id="top" @click="moveController(1)">
                <img style="height:50px; width: 30px;" src="../../assets/img/move/top.png" alt="向下" />
              </div>
              <!-- <div id="middle"></div> -->
              <div id="left" @click="moveController(3)">
                <img style="height:30px; width: 50px;" src="../../assets/img/move/left.png" alt="向左" />
              </div>
              <div id="right" @click="moveController(4)">
                <img style="height:30px; width: 50px;" src="../../assets/img/move/right.png" alt="向右" />
              </div>
              <div id="bottom" @click="moveController(2)">
                <img style="height:50px; width: 30px;" src="../../assets/img/move/bottom.png" alt="向下" />
              </div>

            </div>
          </bm-control>

          <!-- <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation> -->
          <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_RIGHT">
          </bm-map-type>
          <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>

          <bm-marker v-for="(item,index) in carDataList" :key="index"
            :position="{lng: item.longitudeStr, lat: item.latitudeStr}" @click="infoWindowOpen(index)"
            :massClear="false"
            :icon="{url: item.status==1?iconPath.free:(item.status==0?iconPath.exception:(item.status==2?iconPath.mobile:iconPath.coin)),size: {width: 50, height: 65},opts:{imageSize:{width: 50, height: 50}}}">
            <bm-info-window :show="item.isShow" @close="infoWindowClose(index)">
              <p class="bm-marker-info">
                车辆名称:{{item.name}}
              </p>
              <p class="bm-marker-info">
                车辆ID:{{item.idStr}}
              </p>
              <p class="bm-marker-info">
                车辆状态:{{item.status==1?"在线":(item.status==0?"离线":(item.status==2?"接管":"移动"))}}
              </p>
              <button v-show="item.status==1?false:(item.status==2?false:(item.status==3?false:true))"
                class="btn-info-window-start" @click="controllerCar(item.idStr, 1)"
                v-if="item.status==1?false:true">开启</button>
              <button v-show="item.status==0?false:true" class="btn-info-window-move"
                @click="controllerCar(item.idStr, 3)" v-if="item.status==3?false:true">移动</button>
              <button v-show="item.status==0?false:true" class="btn-info-window-stop"
                @click="controllerCar(item.idStr, 0)" v-if="item.status==0?false:true">停止</button>
              <button v-if="item.status==0?false:true"
                :class="isImgShow == true ? 'btn-info-window-adaptor-jie' : 'btn-info-window-adaptor'"
                @click="massageMove(item.idStr, item.status)">
                <span v-if="isImgShow === true && item.status === 2">停止接管</span>
                <span v-else>接管</span>
              </button>
            </bm-info-window>

          </bm-marker>

        </baidu-map>

      </el-col>
    </el-row>
  </div>
  </div>
</template>

<script>
  // const Layout = () => import('components/content/layout')

  import radio from '@/components/common/radio'
  import radioList from '@/components/common/radioList'
  import paginationEasy from '@/components/common/Pagination'
  import {
    getCarList,
    getCarById,
    getVirtualCarList,
    doAction,
    updateCarType
  } from '@/api/car'

  import {
    remoteControl
  } from '@/api/remote'

  export default {
    name: 'Index',
    components: {
      radio,
      radioList,
      paginationEasy
    },
    data() {
      return {

        // 自适应状态
        selfAdaption: true,

        screenWidth: document.body.clientWidth, // 屏幕宽
        screenHeight: document.body.clientHeight, // 屏幕高

        // 长度
        legthLi: '20px',

        // 查询框
        listQuery: '',

        timerCon: null,

        clickCarId: '',

        // rockerCon:200,

        show: {
          degree: 0,
          angle: 0, //方向角度
          level: 0, //速度等级
          quadrant: 0, //象限
        },

        angleSend: 0, //方向角度
        levelSend: 0, //速度等级
        quadrantSend: 0, //象限

        //控制相关
        rocker: undefined,

        /* 列表 */
        startObject: '',
        stopObject: '',
        minaObject: '',
        moveObject: '',
        dataCarListReq: {
          pageIndex: '1',
          pageSize: '10',
        },
        /* 车辆地图list */
        carDataList: [],

        /* 点击列表值 */
        currentIndex: 0,

        actionObject: {
          idList: [],
          action: '',
        },

        /* 按钮 */
        payType: '0',
        radios: [{
            label: '开启',
            value: '1',
            isChecked: false,
          },
          {
            label: '停止',
            value: '2',
            isChecked: false,
          },
        ],
        columns: {
          col1: 5,
          col2: 0,
          col3: 18,
          show_zoom_map: false
        },


        isImgShow: false,

        showRoomMapMsg: "显示",
        // 车辆列表部分
        listLoadingCar: true,
        listDataCar: [],
        totalCountsCar: 30,
        listQueryCar: {
          entityId: this.$store.getters['user/entityId'],
          pageIndex: 1,
          pageSize: 10,
          params: {
            id: undefined,
            isRobot: undefined,
          },
          fuzzySearch: true
        },
        isCheckCar: false,
        // 点云地图
        fileMap: undefined,
        size: [400, 400],
        minSize: 20,
        showRoomMapInterval: undefined,
        insideCarImg: undefined,
        tailImg: undefined,
        // 地图部分
        map: undefined,
        BMap: undefined,
        bdmap: {
          center: "无锡", //{lng: 0, lat: 0}
          zoom: undefined,
          centerCar: {
            lng: 120.373239,
            lat: 31.515
          }
        },
        curCheckCar: false,
        iconPath: {
          free: require('@/assets/img/car_free.9.png'),
          coin: require('assets/img/car_coin_renting.9.png'),
          exception: require('assets/img/car_exception.9.png'),
          reserved: require('assets/img/car_indigo.9.png'),
          mobile: require('assets/img/car_mobile_renting.9.png'),
          maintain: require('assets/img/car_maintaining.9.png'),
          imgUrl: require('assets/img/rocker_base.png')
        },
        getLocationInterval: undefined,
      }
    },
    filters: {

    },
    created() {},
    methods: {

      /**
       * @param {Object} event
       * 创建
       */
      handleResize(event) {
        this.fullWidth = document.documentElement.clientWidth
        console.log(this.fullWidth);
      },

      /**
       * @param {Object} carId
       * 接管按钮
       */
      massageMove(carId, status) {

        this.clickCarId = carId;

        if (status == 2 && this.isImgShow == true) {

          status = 1;
          //this.isImgShow = false;
        } else {

          status = 2;
          // this.isImgShow = true;
        }

        updateCarType(carId, status).then(data => {
          if (data.result == 0 || data.result == 1) {
            this.$message({
              message: "操作成功",
              type: 'info'
            })
            this.setCarList();
            this.showCar(this.clickCarId, status);
          } else {
            this.$message({
              message: "操作失败，请重试",
              type: 'info'
            })
          }
        })
        // this.isImgShow = !this.isImgShow;

      },

      /**
       * @param {Object} val
       * 接管移動
       */
      moveController(val) {

        if (this.clickCarId != null && val != null) {

          remoteControl(this.clickCarId, val).then(data => {
            if (data.result == 0 || data.result == 1) {
              console.log("ccu操作成功！");
              this.setCarList();
              this.showCar(this.clickCarId);
            } else {
              console.log("ccu操作失败！");
            }
          })
        }

      },



      /* 搜索栏查询 */
      handleFilterCar() {

        this.setCarList();

      },

      /* 选择点击 */
      showCar(item, status) {

        this.clickCarId = item;

        if (this.currentIndex != item) {

          this.currentIndex = item;
        } else {
          this.currentIndex = "0";

        }

        // 接管操作显示

        if (this.carDataList != null) {
          for (var i = 0; i < this.carDataList.length; i++) {
            if (item == this.carDataList[i].idStr) {
              console.log(this.carDataList[i].status, status);
              if (this.carDataList[i].status == 2) {
                if (status == null) {

                  this.isImgShow = true;
                } else {

                  this.isImgShow = false;
                }
              } else {
                if (status == 2) {

                  this.isImgShow = true;
                } else {
                  this.isImgShow = false;
                  }
              }

              let bmpoints = []
              bmpoints.push(new this.BMap.Point(this.carDataList[i].longitudeStr, this.carDataList[i].latitudeStr))
              this.map.setViewport(bmpoints)

            }

          }
        }



        console.log(this.isImgShow, "ss");
      },

      /**
       * 一键开启按钮事件处理
       */
      startAllCar() {
        // this.isImgShow = false;
        let idListStr = [];
        /* for (var i = 0; i < this.carDataList.length; i++) {

          if (this.carDataList[i].status == 0) {
            idListStr.push(this.carDataList[i].idStr);

          }

        } */

        this.actionObject.idList = idListStr;
        this.actionObject.action = 1;
        this.doActionCar();
      },

      /**
       * 一键停止按钮事件处理
       */
      stopAllCar() {
        // this.isImgShow = false;
        let idListStr = [];
        /* for (var i = 0; i < this.carDataList.length; i++) {
          if (this.carDataList[i].status != 0) {
            idListStr.push(this.carDataList[i].idStr);
          }
        } */

        this.actionObject.idList = idListStr;
        this.actionObject.action = 0;
        this.doActionCar();
      },

      /**
       * 一键移动按钮事件处理
       */
      moveAllCar() {
        // this.isImgShow = false;
        let idListStr = [];
        /* for (var i = 0; i < this.carDataList.length; i++) {
          if (this.carDataList[i].status == 1) {
            idListStr.push(this.carDataList[i].idStr);
          }
        }
 */
        this.actionObject.idList = idListStr;
        this.actionObject.action = 3;
        this.doActionCar();
      },

      /**
       * 操作按钮事件处理
       */
      doActionCar() {

        console.log(this.actionObject);
        doAction(this.actionObject).then(res => {

          if (res.result === '1') {
            this.$message({
              message: "操作成功",
              type: 'info'
            })
            this.setCarList();

          } else if (res.result === '3') {
            this.$message({
              message: "没有开启车辆",
              type: 'info'
            })
          } else {
            this.$message({
              message: "网络异常，请重试",
              type: 'info'
            })

          }
        }) // deleteCarController
      },

      // 获取列表
      setCarList() {

        if (this.listQuery === '') {

          getVirtualCarList("list", this.dataCarListReq.pageIndex, this.dataCarListReq.pageSize, this.payType).then(
            res => {

              this.startObject = res.map.startMap;
              this.stopObject = res.map.stopMap;
              this.minaObject = res.map.minaMap;
              this.moveObject = res.map.moveMap;
              this.carDataList = res.data;
              this.totalCountsCar = res.count;

            })
        } else {
          getVirtualCarList(this.listQuery, this.dataCarListReq.pageIndex, this.dataCarListReq.pageSize, this.payType)
            .then(res => {
              this.startObject = res.map.startMap;
              this.stopObject = res.map.stopMap;
              this.minaObject = res.map.minaMap;
              this.moveObject = res.map.moveMap;
              this.carDataList = res.data;
              this.totalCountsCar = res.count;

            })

        }

      },

      /**
       * @param {Object} index
       * 点击选择车辆状态
       */
      checkRadio(index) {
        // 先取消所有选中项
        this.radios.forEach((item) => {
          item.isChecked = false;
        });
        //再设置当前点击项选中
        this.payType = this.radios[index].value;
        // 设置值，以供传递
        this.radios[index].isChecked = true;
        console.log(this.payType);

        this.setCarList();

      },
      loadData() {

        _this.payType = data.FPayType
        if (data.FPayType === "开启") {
          _this.$set(_this.radios[0], 'isChecked', true)
          _this.$set(_this.radios[1], 'isChecked', false)
        } else {
          _this.$set(_this.radios[0], 'isChecked', false)
          _this.$set(_this.radios[1], 'isChecked', true)
        }
      },

      /**
       * 处理小车列表翻页
       * @param {Object} data
       */
      handlePageChangeCar(data) {
        console.log("当前页", data);
        this.dataCarListReq.pageIndex = data.page
        this.dataCarListReq.pageSize = data.limit
        this.setCarList();
      },
      /**
       * 清理类型条件
       */
      listQueryClear() {
        this.listQueryCar.params.id = undefined
        this.listQueryCar.params.isRobot = undefined
      },
      //--------------------------------------------------------------------------------------------------------------------------------------------
      /**
       * 显示点云地图
       */
      handleShowRoomMap() {
        clearInterval(this.showRoomMapInterval)
        if (this.columns.show_zoom_map) {
          this.columns.col2 = 0
          this.columns.col3 = 18
          this.showRoomMapMsg = "显示"
          clearInterval(this.showRoomMapInterval)
        } else {
          if (!this.isCheckCar) {
            this.$message({
              type: 'info',
              message: '请选择要显示的小车'
            })
            return
          }
          this.columns.col2 = 12
          this.columns.col3 = 6
          this.showRoomMapMsg = "隐藏"
          this.showRoomMap()
        }
        this.columns.show_zoom_map = !this.columns.show_zoom_map
      },
      initRoomMapTable(ids) {
        document.querySelector("#roomMapTable").innerHTML = ""
        let left = ids.length;
        let pos = left % 2;
        let lines = 0;
        if (pos == 1) {
          lines = (left + 1) / 2;
        } else {
          lines = left / 2;
        }
        let inner = "";
        for (let i = 0; i < lines; i++) {
          let id1 = 2 * i;
          let id2 = id1 + 1;
          inner += "<tr><td><div id='div" + id1 + "'><canvas id='canvas" + id1 +
            "' width='400' height='400' style='border:1px solid #d3d3d3;background:#ffffff;'>不支持canvas</canvas></div></td><td><div id='div" +
            id2 + "'><canvas id='canvas" + id2 +
            "' width='400' height='400' style='border:1px solid #d3d3d3;background:#ffffff;'>不支持canvas</canvas></div></td></tr>";
          if (id2 < ids.length) {
            inner += "<tr><td>" + ids[id1] + "</td><td>" + ids[id2] + "</td></tr>"
          } else {
            inner += "<tr><td>" + ids[id1] + "</td><td></td></tr>"
          }
        }
        document.querySelector("#roomMapTable").innerHTML = inner
        let that = this
        // this.showRoomMapInterval=setInterval(function(){
        //         that.paintByIds(ids);
        // },5000);
      },
      async showRoomMap() {
        clearInterval(this.showRoomMapInterval)
        let ids = [];
        if (this.isCheckCar) {
          ids = this.curCheckCar.map(item => {
            return item.id
          })
        }
        this.initRoomMapTable(ids)
        this.fileMap.clear()
        let count = 0
        let that = this
        let timer;
        for (let carId of ids) {
          canvasPic(carId).then(res => {
            // this.fileMap.carId=imgUrl('1',carId,res.message)
            localDown('1', carId, res.message).then(res => {
              this.fileMap.set(carId, window.URL.createObjectURL(new Blob([res])))
              count++
              if (count == ids.length) {
                // this.paintByIds(ids)
                this.showRoomMapInterval = setInterval(function() {
                  that.paintByIds(ids);
                }, 5000);
              }
            })
          })
          // 睡眠解决 ftp重新连接报错问题
          await this.sleep(1000);
        }
      },
      sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
      },
      paintByIds(ids) {
        let that = this
        for (let i = 0; i < ids.length; i++) {
          let carId = ids[i];
          getCarLocationMapApi(carId).then(data => {
            if (data) {
              let canvasId = "#canvas" + i;
              let canvasItem = document.querySelector(canvasId);
              // console.log(canvasItem)
              this.loadImages(this.fileMap.get(carId), function(images) {
                let ctx = canvasItem.getContext("2d");
                ctx.clearRect(0, 0, 400, 400);
                ctx.drawImage(images, 0, 0, that.size[0], that.size[1]);
                let present = true;
                for (let i = data.length; i-- > 0;) {
                  if (present) {
                    //console.log(data[i]);
                    that.paintImg(canvasItem, that.insideCarImg, data[i].x, data[i].y, that.minSize + i, that
                      .minSize + i);
                    present = false;
                  } else {
                    that.paintImg(canvasItem, that.tailImg, data[i].x, data[i].y, that.minSize + i, that
                      .minSize + i);
                  }
                }
              });

            } else {

            }
          })
        }
      },
      // 异步加载图片
      loadImages(url, callback) {
        let images = new Image();
        let that = this
        images.onload = function() {
          that.size = that.calcSize(images, 400);
          callback(images);
        };
        if (url != undefined) {
          images.src = url;
        }
      },
      paintImg(myCanvas, img, x, y, width, height) {
        let ctx = myCanvas.getContext("2d");
        ctx.drawImage(img, x, y, width, height);
      },
      // 计算大小
      calcSize(img, size) {
        let result = [];
        // console.log(img.width,img.height)
        let width = img.width;
        let height = img.height;
        if (width >= height) {
          result.push(size);
          result.push(height * size / width);
        } else {
          result.push(width * size / height);
          result.push(size);
        }
        return result;
      },
      //---------------------------------------------------------------------------------------------------------------------------------------
      /**
       * 选择项发生变化处理
       * @param {Object} rows 当前选择项
       */
      handleChooseCar(rows) {
        console.log(rows)
        if (rows.length === 0) {
          this.curCheckCar = this.listDataCar
          this.isCheckCar = false
        } else {
          this.curCheckCar = rows
          this.isCheckCar = true
        }
        this.bmAdaptiveHandler(this.curCheckCar)
        if (this.columns.show_zoom_map) {
          this.showRoomMap()
        }
      },
      /**
       * 百度地图ready
       */
      bm_ready({
        BMap,
        map
      }) {
        this.BMap = BMap
        this.map = map
      },

      adaptorClick() {


      },

      bmlStop() {
        this.bmlLushu_play = false
      },
      /**
       * 百度地图自适应处理
       */
      bmAdaptiveHandler(points) {
        let bmpoints = []
        for (const item of points) {
          bmpoints.push(new this.BMap.Point(item.baiduLongitude, item.baiduLatitude))
        }
        this.map.setViewport(bmpoints)
      },
      /**
       * 标注点的弹出框
       * @param {Object} pos
       */
      infoWindowOpen(pos) {

        this.carDataList[pos].isShow = true

      },
      infoWindowClose(pos) {
        this.carDataList[pos].isShow = false
      },
      controllerCar(ids, actionStr) {
        this.isImgShow = false;
        /* startCar().then
                console.log(ids); */
        let idListStr = [];
        idListStr.push(ids);


        this.actionObject.idList = idListStr;
        this.actionObject.action = actionStr;

        doAction(this.actionObject).then(res => {

          if (res.result === '1') {
            this.$message({
              message: "操作成功",
              type: 'info'
            })
            this.setCarList();

          } else {
            this.$message({
              message: "网络异常，请重试",
              type: 'info'
            })

          }
        })

      },
      /**
       * @param {Object} carId
       */
      getCarLocationMap(carId) {
        let that = this
        getCarLocationMapApi(carId).then(res => {
          // console.log(res)
          if (res != null && res.length != 0) {
            if (res.length > 2) {
              // let tmp=res.map(item=>{
              //     return{
              //         lng: item.longitude,
              //         lat: item.latitude,
              //     }
              // })
              // that.bmlLushu_path=tmp.map(item=>{
              //     return new BMap.Point(item.lng,item.lat)
              // })
              // that.curLuShuCar=that.curCheckCar[0].id
              // console.log(that.bmlLushu_path)
              // that.map.setCenter(new BMap.Point(that.bmlLushu_path[0].lng,that.bmlLushu_path[0].lat))
              // that.bmlLushu_play=true
              this.beginLushu(res, carId)
            } else {
              console.log("车辆id:" + carId + "轨迹数据长度不够");
            }
          } else {
            console.log("车辆id:" + carId + "无轨迹数据");
          }
        })
      },
      beginLushu(data, carLushuId) {
        this.map.clearOverlays();
        let accDataNew = [];
        //去掉第一条值，从第二条数据开始取值
        for (let i = 0; i < data.length; i++) {
          if (i == 0) {
            continue;
          }
          accDataNew.push(data[i]);
        }
        //获取data数据中的经纬度点并格式化点为BMap点
        let accPoints = [];
        accPoints = this.getBMapPoints(accDataNew);
        //目标icon
        let accIcon = new BMap.Icon(require('assets/img/car_mobile_renting.9.png'), new BMap.Size(37, 46), {
          // anchor: new BMap.Size(20, 20),
          imageSize: {
            width: 50,
            height: 50
          },
        });

        let polyline = new BMap.Polyline(accPoints, {
          strokeColor: "#DC143C",
          strokeWeight: 10
        });
        this.map.addOverlay(polyline); //添加轨迹到地图

        let lushu = new BMapLib.LuShu(this.map, accPoints, {
          defaultContent: carLushuId,
          speed: 20, //速度，单位米每秒
          icon: accIcon, //声明高铁标注
          autoView: true,
          enableRotation: false,
          landmarkPois: ''
        });
        this.map.setCenter(accPoints[0])
        lushu.start();
      },
      getBMapPoints(data) {
        var points = [];
        for (var i = 0; i < data.length; i++) {
          var x = data[i].longitude;
          var y = data[i].latitude;
          points[i] = new BMap.Point(x, y);
        }
        return points;
      },

      checkLeave() {
        clearInterval(this.getLocationInterval);
        clearInterval(this.showRoomMapInterval);
        console.log("离开首页！");
      },

      /* remoteIntevel(){
          //定时发送任务
          let that=this
          this.timer=setInterval(function()   //开启循环：每秒出现一次提示框
          {
              that.setCarList();
              console.log("s");
          },5000);
      }, */

    },

    beforeDestroy() {
      this.checkLeave()
    },
    destroyed() {
      window.removeEventListener('beforeunload', this.checkLeave)

    },
    watch: {
      screenWidth(newName, oldName) {
        this.screenWidth = newName;

        if (this.screenWidth > 1800) {
          this.selfAdaption = true;
        } else {
          this.selfAdaption = false;
        }

        //window.reload();
        this.$router.go(0);
      }
      // location.reload()
    },
    mounted() {
      this.setCarList();
      // this.remoteIntevel();
      this.fileMap = new Map()
      this.insideCarImg = new Image()
      this.insideCarImg.src = require('assets/img/car_indigo.9.png')
      this.tailImg = new Image()
      this.tailImg.src = require('assets/img/tail.png')
      window.addEventListener('beforeunload', this.checkLeave)

      const that = this;
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth;
          window.screenHeight = document.body.clientHeight;
          that.screenWidth = window.screenWidth;
          that.screenHeight = window.screenHeight;
        })()
      };

      if (this.screenWidth > 1800) {
        this.selfAdaption = true;
      } else {
        this.selfAdaption = false;
      }

    }
  }
</script>

<style>
  .bm-view {
    position: absolute;
    overflow: hidden;
    width: 78%;
    height: 100%;
  }

  .filter-container {
    margin-top: 2%;
    margin-left: -6%;
  }

  .filter-container-max {
    margin-top: 20px;
    margin-left: 20px;
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }


  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .isRobotRadio {
    margin-top: 20px;
    margin-left: 50px;
  }

  .span-start {
    color: #cecece;
    font-size: 15px;

    position: relative;
    /* padding: 35px; */
  }

  .pagination_easy {
    margin-top: 20px;
    /* margin-left: 10px; */
  }

  .radioList {
    margin-top: 0;
    margin-left: 20px;
  }

  .btn-el {
    font-size: 13px;
    color: #9c9c9c;
    background-color: #f3f3f3;
    height: 30px;
    width: 60px;
    line-height: 12px;
    margin-top: 1.25rem;
    border-radius: 3px;
    border-color: #00a792;
    /* margin-bottom: 12px; */
    border: none;
    margin-left: 20px;
    text-align: center;
  }

  .btn-info-window-start {
    font-size: 13px;
    color: #000000;
    background-color: #8bc34a;
    height: 25px;
    width: 50px;
    line-height: 12px;
    margin-top: 1.25rem;
    border-radius: 3px;
    border-color: #00a792;
    /* margin-bottom: 12px; */
    border: none;
    text-align: center;

  }

  .btn-info-window-move {
    font-size: 13px;
    color: #000000;
    background-color: #ffbd76;
    height: 25px;
    width: 50px;
    line-height: 12px;
    margin-top: 1.25rem;
    border-radius: 3px;
    border-color: #00a792;
    /* margin-bottom: 12px; */
    border: none;
    margin-left: 5px;
    text-align: center;

  }

  .btn-info-window-stop {
    font-size: 13px;
    color: #000000;
    background-color: #fe6553;
    height: 25px;
    width: 50px;
    line-height: 12px;
    margin-top: 1.25rem;
    border-radius: 3px;
    border-color: #00a792;
    /* margin-bottom: 12px; */
    border: none;
    margin-left: 5px;
    text-align: center;

  }

  .btn-info-window-adaptor {
    font-size: 13px;
    color: #000000;
    background-color: #92d0fc;
    height: 25px;
    width: 50px;
    line-height: 12px;
    margin-top: 1.25rem;
    border-radius: 3px;
    border-color: #00a792;
    /* margin-bottom: 12px; */
    border: none;
    margin-left: 5px;
    text-align: center;

  }

  .btn-info-window-adaptor-jie {
    font-size: 13px;
    color: #000000;
    background-color: #92d0fc;
    height: 25px;
    width: 60px;
    line-height: 12px;
    margin-top: 1.25rem;
    border-radius: 3px;
    border-color: #00a792;
    /* margin-bottom: 12px; */
    border: none;
    margin-left: 5px;
    text-align: center;

  }

  .bm-marker-info {
    font-size: 16px;
    font-family: "楷体";
  }

  .my-map-type {
    width: 180px;
    height: 180px;

  }

  .my-map-type-shoubing {
    width: 100px;
    height: 100px;
    margin-left: -140px;
  }

  .radio-box {
    display: inline-block;
    position: relative;
    height: 25px;
    line-height: 25px;
    margin-top: 20px;
    margin-left: 40px;
  }

  .input-radio {
    display: inline-block;
    position: absolute;
    opacity: 0;
    width: 25px;
    height: 25px;
    cursor: pointer;
    left: 0px;
    outline: none;
    -webkit-appearance: none;
  }

  .radio {
    display: inline-block;
    width: 25px;
    height: 25px;
    vertical-align: middle;
    cursor: pointer;
    background-image: url(../../assets/img/car/circle.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .on {
    background-image: url(../../assets/img/car/circle_click1.png);
    background-size: 100% 100%;

  }

  .start-end {
    margin-top: 2%;
    margin-left: 2%;
  }

  .start-end-max {
    margin-top: 20px;
    margin-left: 20px;
  }

  .span-start {
    color: #cecece;
    font-size: 15px;

    position: relative;
    /* padding: 35px; */
  }

  .pagination-easy-style {
    margin-left: -10%;
  }

  .pagination-easy-style-max {
    margin-left: -5%;
  }

  .active {
    margin-top: 2%;
    margin-left: 20px;
  }

  .active-max {
    margin-top: 20px;
    margin-left: 20px;
  }

  /* .filter-item1 {
    color: #000000;
    background-color: #f3f3f3;
    height: 34px;
    width: 100px;
    line-height: 12px;
    border-radius: 3px;
    margin-bottom: 30px;
    border: none;
  } */

  .front {
    border-radius: 50% !important;
    background: url(../../assets/img/shoubing1.png) !important;
    background-size: contain !important;
    opacity: 1 !important;
  }

  .back {
    border-radius: 50% !important;
    background: url(../../assets/img/rocker_base.png) !important;
    background-size: contain !important;
    opacity: 1 !important;
  }

  .nipple {
    opacity: 1 !important;
  }

  .rockerCon {
    margin-left: 300px;
  }

  .rockerConClick {
    margin-left: 200px;
  }


  #left,
  #right {
    height: 30px;
    width: 50px;
    position: absolute;
    /* top: 4.6875rem;
    left: 32.5625rem; */

  }

  #top,
  #bottom {
    height: 50px;
    width: 30px;
    position: absolute;
  }

  #top {
    margin: -75px 0 0 -25px;

    opacity: 0.6;
  }

  /* #middle {
    margin: -25px 0 0 -25px;
    background: #000000;
    opacity: 0.6;
  }
 */
  #left {
    margin: -25px 0 0 -60px;

    opacity: 0.6;
  }

  #right {
    margin: -25px 0 0 -10px;

    opacity: 0.6;
  }

  #bottom {
    margin: 5px 0 0 -25px;

    opacity: 0.6;

  }
</style>
